import { validateFitted } from '../utils/validation.js';
import { mean, median, mode } from '../utils/stats.js';

export class SimpleImputer {
  constructor(options = {}) {
    this.strategy = options.strategy || 'mean';
    this.fillValue = options.fillValue;
    this.missingValues = options.missingValues !== undefined ? options.missingValues : null;
    
    this.statistics = null;
    this.isFitted = false;
  }

  _isMissing(value) {
    if (this.missingValues === null) {
      return value === null || value === undefined || (typeof value === 'number' && isNaN(value));
    }
    return value === this.missingValues;
  }

  fit(X) {
    if (!Array.isArray(X[0])) {
      X = X.map(val => [val]);
    }
    
    const nFeatures = X[0].length;
    this.statistics = Array(nFeatures);
    
    for (let j = 0; j < nFeatures; j++) {
      const column = X.map(row => row[j]).filter(val => !this._isMissing(val));
      
      if (column.length === 0) {
        this.statistics[j] = 0;
        continue;
      }
      
      if (this.strategy === 'mean') {
        const numericColumn = column.filter(val => typeof val === 'number');
        this.statistics[j] = numericColumn.length > 0 ? mean(numericColumn) : 0;
      } else if (this.strategy === 'median') {
        const numericColumn = column.filter(val => typeof val === 'number');
        this.statistics[j] = numericColumn.length > 0 ? median(numericColumn) : 0;
      } else if (this.strategy === 'most_frequent') {
        this.statistics[j] = mode(column);
      } else if (this.strategy === 'constant') {
        this.statistics[j] = this.fillValue !== undefined ? this.fillValue : 0;
      } else {
        throw new Error(`Unknown strategy: ${this.strategy}`);
      }
    }
    
    this.isFitted = true;
    return this;
  }

  transform(X) {
    validateFitted(this.isFitted, 'SimpleImputer');
    
    if (!Array.isArray(X[0])) {
      X = X.map(val => [val]);
    }
    
    return X.map(row => 
      row.map((val, j) => this._isMissing(val) ? this.statistics[j] : val)
    );
  }

  fitTransform(X) {
    this.fit(X);
    return this.transform(X);
  }
}
